<template>
  <v-sheet v-if="debugMode" class="debug-mode-indicator">
    <v-icon>mdi-bug</v-icon>
    <p class="subtitle-2">Debug Mode Enabled</p>
    <qvoButton text @click="disableDebugMode">Disable</qvoButton>
  </v-sheet>
</template>
        
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import qvoButton from "@/qux-common/qux22/components/molecules/button";

export default {
  name: "DebugModeIndicator",
  components: {
    qvoButton,
  },
  methods: {
    disableDebugMode() {
      this.$store.dispatch("disableDebugMode");
    },
  },
  computed: {
    ...mapGetters({
      debugMode: "getDebugMode",
    }),
  },
};
</script>
        
<style lang="scss" scoped>
.debug-mode-indicator {
  display: flex;
  align-items: center;
  gap: $qvo-spacing-8;
  z-index: 1000;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  padding: $qvo-spacing-8;
  border-radius: $qvo-spacing-8 $qvo-spacing-8 0 0;
  box-shadow: $qvo-shadow-2;
}
</style>